<template>
  <div class="mt-26">
    <v-row class="background-color-white position-fixed z-index-2">
      <!-- comp -->
      <v-col cols="12" class="primary--text pb-1">
        <div class="align-center d-flex pl-3">
          <!-- <v-icon color="primary">mdi-label-percent-outline</v-icon> -->
          <Icon
              class="pr-2"
              name="deals"
              :color="$vuetify.theme.themes.light.primary"
              title="deals"
              :style="{height:'21px'}"
          ></Icon>
          <h3 class="font-weight-semibold text-no-wrap">Deals</h3>
        </div>
      </v-col>
      <!-- comp -->
      <v-col cols="12">
        <scrollactive
          active-class="active-side-nav"
          :highlightFirstItem="true"
          :modifyUrl="false"
          :offset="offset"
          v-on:itemchanged="onItemChanged"
        >
          <v-sheet :width="fixedRowWidth">
            <swiper ref="promoSwiper" :options="{ slidesPerView: 3 }">
              <swiper-slide
                class="d-flex justify-center"
                v-for="(promotion, index) in promotions"
                :key="promotion.department_id"
              >
                <!-- leave id as index (not promotion.id)-->
                <v-btn
                  @click="offsetAtHeader"
                  :id="index"
                  class="scrollactive-item"
                  :to="`#${slug(promotion.department_name)}`"
                  width="85"
                  depressed
                  small
                >
                  <h4
                    class="font-weight-medium no-uppercase swiper-nav-button-content-max-width text-truncate"
                  >
                    {{ getDepartmentDisplayName(promotion.department_id) }}
                  </h4>
                </v-btn>
              </swiper-slide>
            </swiper>
          </v-sheet>
        </scrollactive>
      </v-col>
    </v-row>
    <v-row
      v-for="promotion in promotions"
      :id="slug(promotion.department_name)"
      :key="promotion.department_id"
      class="background-color-white mb-3"
      no-gutters
    >
      <!-- comp -->
      <v-col cols="9" class="primary--text pl-3 py-2 text-truncate">
        <h4 class="font-weight-medium pl-2 text-no-wrap text-truncate">
          {{ getDepartmentDisplayName(promotion.department_id) }}
        </h4>
      </v-col>
      <v-col cols="3" class="d-flex justify-center">
        <router-link
          class="align-center d-flex font-size-sm"
          :to="`/deals/${promotion.department_id}`"
        >
          View All
          <v-icon color="primary">mdi-chevron-right</v-icon>
        </router-link>
      </v-col>
      <!-- comp -->
      <v-col cols="12">
        <v-sheet :max-width="fixedRowWidth">
          <swiper :options="{ slidesPerView: 2.25 }">
            <swiper-slide
              class="d-flex justify-center"
              v-for="product in promotion.products"
              :key="product.upc"
            >
              <Product :product="product" :size="'xs'" />
            </swiper-slide>
          </swiper>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row> </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { slug } from "github-slugger";
import Product from "@/components/Product/index.vue";
import Icon from '@/components/UI/Icon.vue'

const offset = { scroll: 480, click: 300 };

export default {
  name: "XsPromotions",
  components: {Icon, Product },
  computed: {
    ...mapGetters("departments", {
      getDepartmentDisplayName: "getDepartmentDisplayName",
    }),
    ...mapState({
      promotions: (state) => state.promotions.data,
    }),
    fixedRowWidth() {
      return this.innerWidth;
    },
    swiper() {
      return this.$refs.promoSwiper.$swiper;
    },
  },
  created() {
    window.addEventListener("resize", this.setInnerWidth);
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      offset: offset.scroll,
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.setInnerWidth);
  },
  methods: {
    offsetAtHeader() {
      this.offset = offset.click;
    },
    onItemChanged(event, currentItem) {
      this.swiper.slideTo(currentItem.id, false, false);
      this.offset = offset.scroll;
    },
    setInnerWidth(event) {
      this.innerWidth = event.target.innerWidth;
    },
    slug,
  },
};
</script>
<style scoped>
.mt-26 {
  margin-top: 104px;
}

.active-side-nav {
  background-color: var(--v-primary-base) !important;
  color: var(--color-white) !important;
}

.position-fixed {
  position: fixed;
  /*top: 194px;*/
  top: 197px;
}

.z-index-2 {
  z-index: 2;
}
</style>
